import { Stack, TextField } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import { CrudPage } from '../../shared/components/CrudPage';
import { resources } from '../../core/services/resources';
import type { AIModel } from '../../core/types/data-models';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 80 },
  { field: 'name', headerName: 'Name', flex: 1, minWidth: 200 },
  { field: 'aiEngine', headerName: 'Engine', width: 140 },
  { field: 'aiModelIdentifier', headerName: 'Model identifier', flex: 1, minWidth: 220 },
];

export function AIModelsPage() {
  return (
    <CrudPage<AIModel>
      title="AI models"
      description="Catalog of AI engines and their model identifiers used to run prompts."
      cacheKey={['ai-models']}
      service={resources.aiModels}
      columns={columns}
      defaultValues={{ name: '', aiEngine: '', aiModelIdentifier: '', description: null }}
      renderForm={({ values, setValues }) => (
        <Stack spacing={2}>
          <TextField label="Display name" required value={values.name ?? ''} onChange={(e) => setValues({ ...values, name: e.target.value })} />
          <TextField label="AI engine" required value={values.aiEngine ?? ''} onChange={(e) => setValues({ ...values, aiEngine: e.target.value })} placeholder="OPENAI / ANTHROPIC / …" />
          <TextField label="Model identifier" required value={values.aiModelIdentifier ?? ''} onChange={(e) => setValues({ ...values, aiModelIdentifier: e.target.value })} placeholder="gpt-4o, claude-opus-4-7, …" />
          <TextField label="Description" multiline minRows={2} value={values.description ?? ''} onChange={(e) => setValues({ ...values, description: e.target.value === '' ? null : e.target.value })} />
        </Stack>
      )}
    />
  );
}
